import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/idCard-preview.png'


const _hoisted_1 = { class: "mb-40px" }
const _hoisted_2 = { class: "flex items-center gap-4 mt-40px" }
const _hoisted_3 = { class: "w-full md:w-2/3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = { class: "w-full md:w-1/3" }

import { ref, onBeforeUnmount, getCurrentInstance } from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { useStore } from 'vuex'

const employeeDocumentEndpoint = 'talent/v1/employeeDocuments'

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckExistingDataDialog',
  emits: ["openFormEdit", "openFormCreate", "hideDialog"],
  setup(__props, { emit: __emit }) {

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const isShowDataExistDialog = ref(false)
const store = useStore()
const searchIdNumber = ref('')
const existingDataList = ref(null as any)
const confirmDataExistDialog = ref({
  title: 'Karyawan Sudah Terdaftar!',
  subTitle: '',
  btnSubmitTitle: 'Lihat Data Karyawan',
  isHtml: true,
  image: require('@/assets/img/modal-confirmation/existing-data.svg')
})
const errorMessage = ref('')
const showErrorMessage = ref(false)

const emit = __emit

const showDataExistDialog = () => {
  confirmDataExistDialog.value.subTitle = `Data karyawan dengan NIK <span style="font-weight:700">${searchIdNumber.value}</span> sudah terdaftar di database. Klik <span style="color:#04776D; font-weight:700">Lihat Data Karyawan</span> untuk mengakses data karyawan tersebut.`
  isShowDataExistDialog.value = true
}

const hideDataExistDialog = () => {
  searchIdNumber.value = ''
  isShowDataExistDialog.value = false
}

// eslint-disable-next-line consistent-return
const checkInput = () => {
  console.log('search', searchIdNumber.value)
  if (searchIdNumber.value.length === 0) {
    console.log('xxx')
    errorMessage.value = 'NIK tidak boleh kosong'
    showErrorMessage.value = true
    return false
  }
  if (!/^\d+$/.test(searchIdNumber.value)) {
    errorMessage.value = 'NIK hanya boleh berupa angka'
    showErrorMessage.value = true
    return false
  }
  if (searchIdNumber.value.length < 16 || searchIdNumber.value.length > 16) {
    errorMessage.value = 'NIK harus terdiri dari 16 digit'
    showErrorMessage.value = true
    return false
  }
  if (searchIdNumber.value.length === 16) {
    showErrorMessage.value = false
    return true
  }
}

const findExistingData = async () => {
  if (!checkInput()) {
    return
  }
  if (searchIdNumber.value.length > 0) {
    store.dispatch('showLoading')
    const params = {
      custom: [['bypassPagination', '=', 'true'], ['documentNumber', '=', searchIdNumber.value], ['documentTypeName', '=', 'ktp']]
    }
    await apiUseCase.get(employeeDocumentEndpoint, returnUrlPrams(params)).then((response) => {
      const { error, result } = response
      if (!error) {
        const res = result.data
        if (res.length > 0) {
          existingDataList.value = {
            ...res[0],
            id: res[0].employeeId
          }
          showDataExistDialog()
        } else {
          emit('openFormCreate')
        }
      }
    })
    store.dispatch('hideLoading')
  }
}

const toExistingDataDetail = () => {
  emit('openFormEdit', existingDataList.value)
  emit('hideDialog')
}

onBeforeUnmount(() => {
  existingDataList.value = null
  searchIdNumber.value = ''
  isShowDataExistDialog.value = false
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "idCard",
          class: "mx-auto"
        })
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("div", { class: "title" }, "Cek NIK Karyawan"),
        _createElementVNode("div", { class: "sub-title" }, "Masukkan NIK (Nomor Induk Kependudukan) karyawan untuk cek apakah karyawan sudah terdaftar di database atau belum.")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(InputText), {
            type: "text",
            modelValue: searchIdNumber.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchIdNumber).value = $event))
          }, null, 8, ["modelValue"]),
          (showErrorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Button), {
            class: "mb-2 sm:mb-0 flex gap-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (findExistingData()))
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("p", { class: "text-white font-bold text-sm" }, [
                _createElementVNode("i", { class: "pi pi-search" }),
                _createTextVNode(" Cek NIK")
              ], -1)
            ])),
            _: 1,
            __: [2]
          })
        ])
      ])
    ]),
    _createVNode(HjpCofirmModal, {
      show: isShowDataExistDialog.value,
      title: confirmDataExistDialog.value?.title,
      subTitle: confirmDataExistDialog.value?.subTitle,
      btnSubmitTitle: confirmDataExistDialog.value?.btnSubmitTitle,
      subTitleHtml: confirmDataExistDialog.value?.isHtml,
      onHideDialog: hideDataExistDialog,
      onOnSubmit: toExistingDataDetail
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "subTitleHtml"])
  ], 64))
}
}

})